var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocFormF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16353 24.8365 0 16 0C7.16353 0 0 7.16353 0 16C0 23.5034 5.16608 29.7997 12.135 31.529V20.8896H8.83585V16H12.135V13.8931C12.135 8.44737 14.5997 5.92321 19.9463 5.92321C20.96 5.92321 22.7091 6.12224 23.4247 6.32064V10.7526C23.0471 10.713 22.3911 10.6931 21.5763 10.6931C18.953 10.6931 17.9392 11.687 17.9392 14.2707V16H23.1655L22.2675 20.8896H17.9392V31.8829C25.8605 30.9261 32 24.1805 32 16Z",
    fill: "#316FF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocFormF);
export default __webpack_public_path__ + "static/media/soc-form-f.abd6f7a0e8be480c7d5734e92c74c6f7.svg";
export { ForwardRef as ReactComponent };